import { render, staticRenderFns } from "./useraddress.vue?vue&type=template&id=73619a9e&scoped=true"
import script from "./useraddress.vue?vue&type=script&lang=js"
export * from "./useraddress.vue?vue&type=script&lang=js"
import style0 from "./useraddress.vue?vue&type=style&index=0&id=73619a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73619a9e",
  null
  
)

export default component.exports